import type { ReactNode } from 'react';

export function highlightMatch(label: string, query: string): ReactNode {
    const q = query.trim();
    if (!q) return label;
    const idx = label.toLowerCase().indexOf(q.toLowerCase());
    if (idx < 0) return label;
    const before = label.slice(0, idx);
    const match = label.slice(idx, idx + q.length);
    const after = label.slice(idx + q.length);
    return (
        <>
            {before}
            <span className="font-bold">{match}</span>
            {after}
        </>
    );
}
